module.exports = __webpack_public_path__ + "9080c320688cc532037389711df38c37.png";